/**
 * The message envelopes either side of the socket may send.
 *
 * Colyseus is the transport and nothing more (design spec §9.5). It carries
 * these objects; it does not define them, and no game type is declared inside
 * a `Schema` class where the client cannot import it. Colyseus room state is
 * deliberately unused for the world itself: state sync broadcasts one state to
 * every client, and the whole point of area-of-interest culling is that each
 * player is sent a *different* slice. Per-client messages are how that stays
 * true rather than aspirational.
 */
import { INTENT_TYPES } from '@annwn/sim';
/** Channel names. Client → server. */
export const CLIENT_MESSAGE = {
    intent: 'intent',
};
/** Channel names. Server → client. */
export const SERVER_MESSAGE = {
    welcome: 'welcome',
    snapshot: 'snapshot',
    rejected: 'rejected',
    log: 'log',
};
export function parseClientIntent(value) {
    if (typeof value !== 'object' || value === null || Array.isArray(value))
        return null;
    const message = value;
    const seq = message['seq'];
    if (typeof seq !== 'number' || !Number.isInteger(seq) || seq < 0)
        return null;
    const type = message['type'];
    if (typeof type !== 'string' || !INTENT_TYPES.includes(type))
        return null;
    // `join` and `leave` are the server's to issue: a client that could send
    // them could seat itself twice, or evict its own body mid-fight.
    if (type === 'join' || type === 'leave')
        return null;
    return { seq, type: type, payload: message['payload'] ?? {} };
}
//# sourceMappingURL=messages.js.map